query GetEventAttendee($id: ID!) {
  eventAttendee(id: $id) {
    id
    registrationSource
    checkedInAt
    checkedInByName
    outboxEntries {
      id
      kind
      status
      transitionKey
      attempts
      lastError
      createdAt
    }
  }
}
